import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isSet } from '../../../../Utils/CommonFunctions';
import { checkIsOrganizationAdmin } from '../../../../Utils/UserFunctions';
import ProfileService from '../../../../services/ProfileService';
import FieldGroupService from '../../../../services/FieldGroupService';
import { warningMessage } from '../../../../store/actions/CommonActions';
import { loadPagesConfigAction } from '../../../../store/actions/PagesAction';
// import Wrp from '../../../hoc/Wrp/Wrp';
// import {getDateFormat} from '../../../../Utils/UserFunctions';
// import moment from 'moment';

class OtherComponent extends Component {
    state = {
        isCheckingPermission: false,
        fieldDetails: null
    }

    handleClick = async (e) => {
        const {header, colData} = this.props;
        const tableDescriptorId = header?.columnId;
        
        if (!tableDescriptorId) {
            return; // No field ID available
        }

        // Check if field details are already available in header
        let isPagesHyperLink = header?.is_pages_hyper_link;
        let url = header?.url;

        // If not available, fetch field details
        if (isPagesHyperLink === undefined && tableDescriptorId) {
            try {
                this.setState({ isCheckingPermission: true });
                const fieldDetails = await FieldGroupService.getTableDescriptorById(tableDescriptorId);
                if (fieldDetails) {
                    isPagesHyperLink = fieldDetails.is_pages_hyper_link;
                    url = fieldDetails.url;
                    this.setState({ fieldDetails });
                }
            } catch (error) {
                console.error('Error fetching field details:', error);
                this.setState({ isCheckingPermission: false });
                return;
            }
        }

        // If this is a PageLinkForLabel field
        if (isPagesHyperLink === true && url) {
            e.preventDefault();
            const pagesConfigurationId = url; // URL is the page_configuration_id
            
            try {
                this.setState({ isCheckingPermission: true });
                const hasPermission = await ProfileService.checkPagesConfigurationPermission(pagesConfigurationId);
                this.setState({ isCheckingPermission: false });
                
                if (hasPermission) {
                    // Navigate to page
                    if (this.props.loadPagesConfigAction) {
                        this.props.loadPagesConfigAction('ID', pagesConfigurationId, { history: this.props.history });
                    }
                } else {
                    // Show warning message
                    if (this.props.warningMessage) {
                        this.props.warningMessage("You don't have permission for this action. Please contact admin");
                    }
                }
            } catch (error) {
                console.error('Error checking permission:', error);
                this.setState({ isCheckingPermission: false });
                if (this.props.warningMessage) {
                    this.props.warningMessage("You don't have permission for this action. Please contact admin");
                }
            }
        }
    }

    render () {
        const {colData, id, header} = this.props;
        const {isCheckingPermission} = this.state;
        const isAccountAdmin = checkIsOrganizationAdmin();
        
        // Check if this is a PageLinkForLabel field
        const isPagesHyperLink = header?.is_pages_hyper_link || this.state.fieldDetails?.is_pages_hyper_link;
        const url = header?.url || this.state.fieldDetails?.url;
        const isClickable = isPagesHyperLink === true && url;
        
        // Check if this is a currency field with dispute flag (currency_dispute is only set for Currency fields)
        const isCurrencyDispute = isAccountAdmin && colData.currency_dispute === true;
        const textStyle = isCurrencyDispute ? { color: '#d32f2f', fontWeight: 'bold' } : {};
        
        return(
            <td key={id}>
                {isClickable ? (
                    <span 
                        className="cursor-pointer textUnderline" 
                        onClick={this.handleClick}
                        style={{ cursor: isCheckingPermission ? 'wait' : 'pointer', ...textStyle }}
                        title={colData.value}
                    >
                        {isCheckingPermission ? 'Checking...' : colData.value}
                    </span>
                ) : (
                    <span title={colData.value} style={textStyle}>{colData.value}</span>
                )}
            </td>
        );
    }
}

const mapDispatchToProps = {
    warningMessage,
    loadPagesConfigAction
};

export default connect(null, mapDispatchToProps)(withRouter(OtherComponent));